import React, {
  FC
} from 'react';
import {
  useTranslation
} from 'react-i18next';

export const ViaDivider: FC = () => {
  const {
    t
  } = useTranslation();

  return (
    <div className="w-full flex flex-row gap-2">
      <div className="flex flex-col flex-1">
        <div className="border-b border-b-gray-whisper flex-1" />

        <div className="flex-1" />
      </div>

      <div>{t('login.orVia')}</div>

      <div className="flex flex-col flex-1">
        <div className="border-b border-b-gray-whisper flex-1" />

        <div className="flex-1" />
      </div>
    </div>
  );
};
